<template>
  <div class="vueBox">
    <div class="marquee">
      <div class="marquee_box">
        <ul class="marquee_list" :class="{marquee_top:animate}">
          <li v-for="(item, index) in marqueeList" :key="index">
            <p>{{item.name}}</p>
            <p>
              <span>
                  <img :src="item.icon">
              </span>
              <a :href="item.url || 'javascript:;'" target="_blank" style="font-weight:600">{{item.text}}</a>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let that = this;
    return {
      animate: false,
      marqueeList: [
      /*   {
          name: "API咨询",
          icon: "//txwl.huohuoche.com/txws/new_images_one/phone_yellow.png",
          tel: "+63 998 167  6789"
        }, */
        /*{
          name: "立即咨询",
          icon: "//txwl.huohuoche.com/txws/new_images_one/phone_yellow.png",
          tel: "+63  998 167 6789"
        },*/
        {
          name: "立即咨询",
          icon: "//txwl.huohuoche.com/txws/new_images_one/telegram_yellow2.png",
          text: "@TX_GROUP998",
          url: "https://t.me/TX_GROUP998"
        },
      ]
    };
  },
  created: function() {
    // setInterval(this.showMarquee, 2500);
  },
  methods: {
    showMarquee: function() {
      this.animate = true;

      setTimeout(() => {
        this.marqueeList.push(this.marqueeList[0]);
        this.marqueeList.shift();
        this.animate = false;
      }, 500);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
div,
ul,
li,
span,
img {
  margin: 0;
  padding: 0;
}
.marquee {
  width: 100%;
  height: 50px;
  color: #3a3a3a;
  box-sizing: border-box;
}
.marquee_box {
  display: block;
  position: relative;
  width: 100%;
  height: 50px;
  overflow: hidden;
}

.marquee_list {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.marquee_top {
  transition: all .75s;
  margin-top: -50px;
}

.marquee_list li {
  height: 50px;
  line-height: 25px;
  font-size: 20px;
  padding-left: 20px;
  text-align: center;
  p {
    color: $yellow;
    a {
      color: $yellow !important;
    }
    img {
      display: inline-block;
      width: 19px;
      vertical-align: middle;
     /* position: relative;
      top:3px;*/
    }
  }
}

.red {
  color: #ff0101;
}
</style>



// WEBPACK FOOTER //
// src/common/tx-contact.vue